import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { QuestionType } from '@app/shared/enums/QuestionType.enum';

@Pipe({
    name: "questionTypePipe",
    standalone: false
})
export class QuestionTypePipe implements PipeTransform {
  public operationType = QuestionType;
  public questionTypeTypes: any[] = [];

  constructor(public translate: TranslateService) {
    this.getList();
  }

  transform(key: any): any {
    for (let item in this.operationType) {
      if (this.operationType[item] === key)
        return this.translate.instant('ENUMS.QUESTION_TYPE_' + key);
    }
  }

  getList() {
    this.questionTypeTypes = [];
    for (const [propertyKey, propertyValue] of Object.entries(QuestionType)) {
      if (!Number.isNaN(Number(propertyKey))) {
        continue;
      }
      const nameAndText = this.translate.instant('ENUMS.QUESTION_TYPE_' + propertyKey);
      this.questionTypeTypes.push({
        id: propertyKey,
        name: nameAndText,
        text: nameAndText
      });
    }

    return this.questionTypeTypes;
  }

  getById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(QuestionType)) {
      if (propertyValue == Id) {
        const nameAndText = this.translate.instant('ENUMS.' + propertyKey);
        return {
          id: propertyValue,
          name: nameAndText,
          text: nameAndText
        };
      }
    }
    return null;
  }

  getNameById(Id: any) {
    for (const [propertyKey, propertyValue] of Object.entries(QuestionType)) {
      if (propertyValue == Id) {
        return 'ENUMS.' + propertyKey;
      }
    }
    return null;
  }
}
